import { FC, useMemo } from 'react';
import { Avatar, Button } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { fromISOtoFormat } from 'src/common/utils/dataFormat';
import { IVanHost } from 'src/store/reducers/host/types';
import Icons from 'src/common/icons';
import './styles.scss';
import './media.scss';

interface IProps {
  host: IVanHost;
}

const MainHostInfo: FC<IProps> = ({ host }) => {
  const { photo, first_name, created_at, state, city } = host;

  const handleOpen = () => {
    window.open('https://g.page/r/CWZjvuX7lrsHEB0/review', '_blank');
  };

  const rate = useMemo(() => {
    if (host?.feedback.length) {
      const sum = host?.feedback.reduce((total, el) => total + el.rates, 0);
      return Math.ceil((sum / host?.feedback.length) * 10) / 10;
    } else return 4.9;
  }, [host?.feedback]);

  return (
    <div className='main-host'>
      <Avatar alt='user photo' src={photo ?? '/broken-image.jpg'} className='main-host__photo' />
      <div className='main-host__name'>
        <h5>{first_name}</h5>
        <span>
          {state} - {city}
        </span>
      </div>
      <div className='main-host__rating'>
        <span>{rate}</span>
        <StarIcon />
      </div>
      <span className='main-host__joined'>Joined {fromISOtoFormat(created_at, 'MMM yyyy')}</span>
      <div className='main-host__verify'>
        <Icons.Verified />
        <span>Identity verified</span>
      </div>
      <Button className=' main-host__add-review' onClick={handleOpen}>
        Leave a Review
      </Button>
    </div>
  );
};
export default MainHostInfo;
